import { Create, SimpleForm, TopToolbar } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveCampaignForm from "./Partials/SaveForm";

const CreateCampaignForOutgoingStudents = () => {
  return (
    <Create
      title="Създаване на кампания за заминаващи студенти"
      actions={
        <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
          <BackButtonToolbar />
        </TopToolbar>
      }
    >
      <SimpleForm>
        <SaveCampaignForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateCampaignForOutgoingStudents;
